import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Terminal } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, pin });
      login(data.token, data.user);
      toast.success(`Welcome back, ${data.user.full_name.split(" ")[0]}`);
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-fg">
      <div className="max-w-md w-full" data-testid="login-page">
        <Link to="/" className="flex items-center gap-2 mb-10">
          <Terminal size={18} className="text-amber"/>
          <div className="font-display text-xl text-amber">COYOTE/LIFE</div>
        </Link>
        <div className="label-xs text-amber">&gt; SIGN IN</div>
        <h1 className="font-display text-4xl sm:text-5xl leading-none mt-2">Clock in.</h1>
        <p className="mt-3 text-fg-muted font-mono text-sm">Email + 4-digit PIN.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="label-xs mb-1 block">Email</label>
            <input type="email" className="input-term" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
          </div>
          <div>
            <label className="label-xs mb-1 block">PIN</label>
            <input type="password" maxLength={4} inputMode="numeric" className="input-term text-2xl tracking-[0.5em] text-center text-amber" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} required data-testid="login-pin-input" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit-btn" className="btn-primary w-full">
            {loading ? "Auth..." : "Sign In >"}
          </button>
          <div className="flex justify-between text-xs text-fg-muted font-mono">
            <Link to="/forgot-pin" className="text-electric hover:underline" data-testid="forgot-pin-link">Forgot PIN?</Link>
            <Link to="/signup" className="text-amber" data-testid="login-signup-link">Onboard &gt;</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
